import React from 'react'
import { useDisclosure } from '@chakra-ui/react'
import { HamburgerMenu } from './HamburgerMenu'
import { MenuBar } from './MenuBar'
import { useHistory } from 'react-router-dom'

export default function Header() {
  const { isOpen, onToggle } = useDisclosure()
  const history = useHistory()
  const navigate = (url) => {
    history.push(url)
  }

  return (
    <div className='sticky z-50 top-[0px] w-[100vw] bg-almost-black flex items-center justify-center'>
      <div className='sticky z-50 bg-almost-black w-[100vw] lg:max-w-[1440px]'>
        <div className='py-5 flex items-center mx-auto px-6 lg:px-20'>
          <img
            src='/static/2024/svg/yes-2024.svg'
            alt='YES 2024 Logo'
            className='w-[120px] h-auto cursor-pointer'
            onClick={() => navigate('/2024/home')}
          />
          <div className='grid w-full justify-end gap-4 lg:hidden'>
            <HamburgerMenu isOpenMenuNavs={isOpen} toggleMobileNavs={onToggle} />
          </div>
          <div className='grid w-full justify-end gap-4 hidden lg:block'>
            <MenuBar />
          </div>
        </div>
      </div>
    </div>
  )
}
